import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ProductDpiFieldController extends Controller {
  static targets = ['field']

  connect () {
    this.update()
  }

  update () {
    const selected = this.element.querySelector('input[name="product[product_type]"]:checked')
    const show = selected && ['custom', 'print_on_demand'].includes(selected.value)
    this.fieldTarget.classList.toggle('hidden', !show)
  }
}

stimulus.register('product-dpi-field', ProductDpiFieldController)
